import { BaseConditionData } from './base-condition-data';
import { WorkflowConditionTypes } from './Enums/workflow-condition-types';

/**
 * Représente les données d'une condition 'Expression logique'.
 */
export class LogicalExpressionConditionData extends BaseConditionData {
    /**
     * Expression logique à respecter.
     */
    public expression: number = null;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowConditionTypes.LogicalExpression);
    }

    /**
     * Retourne une copie d'une instance de LogicalExpressionConditionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: LogicalExpressionConditionData) {
        if (!!other) {
            const instance = new LogicalExpressionConditionData();
            instance.expression = other.expression;
            instance.name = other.name;
            instance.type = other.type;
            instance.id = other.id;
            instance.isMainCondition = other.isMainCondition;

            return instance;
        } else {
            return null;
        }
    }
}
